class EventDispatcher {
  /**
   * Adds event listener
   *
   * @param {string} type - The type of the event
   * @param {function} listener - The listener function
   */
  addEventListener(type, listener) {
    if (this.listeners === undefined) {
      this.listeners = {};
    }
    const listeners = this.listeners;
    if (listeners[type] === undefined) {
      listeners[type] = [];
    }
    if (listeners[type].indexOf(listener) === -1) {
      listeners[type].push(listener);
    }
  }

  /**
   * Remove event listener
   *
   * @param {string} type - The type of the event
   * @param {function} [listener] - The listener function,
   * if omitted this will remove all events of the specified type
   */
  removeEventListener(type, listener) {
    if (this.listeners === undefined) {
      return false;
    }
    const listeners = this.listeners;
    const listenersArray = listeners[type];

    if (listenersArray !== undefined) {
      if (listener) {
        const index = listenersArray.indexOf(listener);
        if (index !== -1) {
          listenersArray.splice(index, 1);
        }
      } else {
        listenersArray.length = 0;
      }
    }
  }

  /**
   * Emits an event
   * @param {string} type - The type of the event
   * @param {any} [args] - Any arguments to pass with the event
   */
  dispatchEvent(type, ...args) {
    if (this.listeners === undefined) {
      return;
    }
    const listeners = this.listeners;
    const listenersArray = listeners[type];
    if (listenersArray !== undefined) {
      for (let i = 0; i < listenersArray.length; i++) {
        listenersArray[i].apply(this, args);
      }
    }
  }

  /**
   * Adds event listener
   *
   * @param {string} type - The type of the event
   * @param {function} listener - The listener function
   */
  on(type, listener) {
    this.addEventListener(type, listener);
  }

  /**
   * Remove event listener
   *
   * @param {string} type - The type of the event
   * @param {function} listener - The listener function,
   * if omitted this will remove all events of the specified type
   */
  off(type, listener) {
    this.removeEventListener(type, listener);
  }

  /**
   * Emits an event
   * @param {string} type - The type of the event
   * @param {any} [args] - Any arguments to pass with the event
   */
  emit(type, ...args) {
    this.dispatchEvent.apply(this, arguments);
  }

  /**
   * Gets if there is an
   * @param {string} type - The type of the event to search for
   * @param {function} listener - The listener of the event to search for
   */
  has(type, listener) {
    if (this.listeners === undefined) {
      return false;
    }
    const listeners = this.listeners;
    if (listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1) {
      return true;
    }
    return false;
  }

  /**
   * Remove all listeners
   */
  dispose() {
    delete this.listeners;
  }
}

export default EventDispatcher;



// WEBPACK FOOTER //
// ./public/js/chyronhego/events/EventDispatcher.js